import { Injectable } from '@angular/core';
import { RestApiService, PaginatedResponse } from './rest-api.service';
import { Observable } from 'rxjs';
import { Company, Project } from '../models/base.model';

@Injectable({
  providedIn: 'root'
})
export class ApiCompanyService extends RestApiService {

  // Admin Company Related

  /**
   * Get paginated list of companies
   * Uses the new getList helper method - reduced from 10 lines to 1 line
   */
  public apiGetObjects(params: any = {}): Observable<PaginatedResponse<Company>> {
    return this.getList('companies/', Company.parse, params);
  }

  /**
   * What the current user may do with this company (roles + capability flags).
   */
  public apiGetPermissions(id: any, params: any = {}): Observable<any> {
    return this.getRaw(`companies/${id}/permissions/`, params);
  }

  /**
   * Get a single company by ID
   * Uses the new getSingle helper method - reduced from 9 lines to 1 line
   */
  public apiGetObject(id: any, params: any = {}): Observable<Company> {
    return this.getSingle(`companies/${id}/`, Company.parse, params);
  }

  /**
   * Create a new company
   * Uses the new postSingle helper method - reduced from 10 lines to 1 line
   */
  public apiPostObject(payload: any, params: any = {}): Observable<Company> {
    return this.postSingle('companies/', payload, Company.parse, params);
  }

  /**
   * Update an existing company
   * Uses the new putSingle helper method - reduced from 9 lines to 1 line
   */
  public apiPutObject(id: any, payload: any, params: any = {}): Observable<Company> {
    return this.putSingle(`companies/${id}/`, payload, Company.parse, params);
  }

  /**
   * Delete a company
   * Uses the new deleteSingle helper method - reduced from 8 lines to 1 line
   */
  public apiDeleteObject(id: any, params: any): Observable<any> {
    return this.deleteSingle(`companies/${id}/`, params);
  }

  /**
   * Get paginated list of projects for company
   * Uses the new getList helper method - reduced from 10 lines to 1 line
   */
  public apiGetProjects(id: any, params: any = {}): Observable<PaginatedResponse<Project>> {
    return this.getList(`companies/${id}/`, Project.parse, params);
  }

  /**
   * 
   */
  public apiGetAppSettings(id: any, params: any = {}): Observable<any> {
    return this.getRaw(`companies/${id}/app-settings/`, params);
  }
}

@Injectable({
  providedIn: 'root'
})
export class ApiCompanySiteService extends RestApiService {

  // Admin Company Related

  /**
   * Get paginated list of companies
   * Uses the new getList helper method - reduced from 10 lines to 1 line
   */
  public apiGetObjects(params: any = {}): Observable<PaginatedResponse<Company>> {
    return this.getList('sites/', Company.parse, params);
  }

  /**
   * What the current user may do with this site (roles + capability flags).
   */
  public apiGetPermissions(id: any, params: any = {}): Observable<any> {
    return this.getRaw(`sites/${id}/permissions/`, params);
  }

  /**
   * Get a single company by ID
   * Uses the new getSingle helper method - reduced from 9 lines to 1 line
   */
  public apiGetObject(id: any, params: any = {}): Observable<Company> {
    return this.getSingle(`sites/${id}/`, Company.parse, params);
  }

  /**
   * Create a new company
   * Uses the new postSingle helper method - reduced from 10 lines to 1 line
   */
  public apiPostObject(payload: any, params: any = {}): Observable<Company> {
    return this.postSingle('sites/', payload, Company.parse, params);
  }

  /**
   * Update an existing company
   * Uses the new putSingle helper method - reduced from 9 lines to 1 line
   */
  public apiPutObject(id: any, payload: any, params: any = {}): Observable<Company> {
    return this.putSingle(`sites/${id}/`, payload, Company.parse, params);
  }

  /**
   * Delete a company
   * Uses the new deleteSingle helper method - reduced from 8 lines to 1 line
   */
  public apiDeleteObject(id: any, params: any): Observable<any> {
    return this.deleteSingle(`sites/${id}/`, params);
  }

  /**
   * Get paginated list of projects for company
   * Uses the new getList helper method - reduced from 10 lines to 1 line
   */
  public apiGetProjects(id: any, params: any = {}): Observable<PaginatedResponse<Project>> {
    return this.getList(`sites/${id}/`, Project.parse, params);
  }

  /**
   * Get service status for a site (raw response, no parsing)
   */
  public apiGetServiceStatus(id: any, params: any = {}): Observable<any> {
    return this.getRaw(`sites/${id}/service-status/`, params);
  }


}